module.exports = __webpack_public_path__ + "img/mutasi.fd834edf.svg";